import React from "react";
import SavedPlace from "../../../components/SavedPlace/SavedPlace";
import { ISavedPlace } from "../../../models/SavedPlace";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { useTranslation } from "react-i18next";
import { NoSavedPlaces } from "../../../components/NoSavedPlaces/NoSavedPlaces";
import { Spin } from "antd";
import { useNavigate } from "react-router";
import styles from "../Profile.module.scss";
import { useGetAllSavedPlacesQuery } from "../../../api/queries";
import { useSavedPlacedMutations } from "../../../api/mutations";
import { handleError } from "../../../helper/errorHandler";

const SavedPlaces: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data, isLoading, isError, refetch } = useGetAllSavedPlacesQuery();
  const { deletePlace } = useSavedPlacedMutations();

  const onDeleteSavedPlace = async (id: string) => {
    deletePlace(
      { id },
      {
        onSuccess: () => refetch(),
        onError: (e) => handleError(e, dispatch, t),
      }
    );
  };

  const onNavigateToGym = (id: string) => {
    if (!id) return;

    navigate(`/gyms-location/${id}`);
  };

  return (
    <div
      className={styles.wrapper}
      style={{
        justifyContent: data?.length === 0 || isLoading ? "space-between" : "flex-start",
        marginBottom: 30,
      }}
    >
      <h1 className={styles.title}>{t("SavedPlaces")}</h1>

      {isLoading ? (
        <div className={styles.spinnerWrapper}>
          <Spin size="large" />
        </div>
      ) : !data || data?.length === 0 || isError ? (
        <NoSavedPlaces />
      ) : (
        <ul className={styles.list}>
          {data?.map((place: ISavedPlace) => (
            <SavedPlace
              place={place}
              key={place.id}
              onPressHeart={onDeleteSavedPlace}
              onPress={onNavigateToGym}
            />
          ))}
        </ul>
      )}

      {data?.length === 0 || (isLoading && <span />)}
    </div>
  );
};

export default SavedPlaces;
